module.exports = __webpack_public_path__ + "static/media/icon-offer-shortime.98b9aaf6.svg";